export const brandsConstants = {
  BRANDS_ALL_REQUEST: 'BRANDS_ALL_REQUEST',
  BRANDS_ALL_SUCCESS: 'BRANDS_ALL_SUCCESS',
  BRANDS_ALL_ERROR: 'BRANDS_ALL_ERROR',
};
